import React from 'react';
import styled, { css } from 'styled-components';
import palette from '../../lib/styles/palette';
import Cell from './Cell';
import Button from '../common/Button';
import Loading from '../common/Loading';
import { FiPlus, FiEdit2, FiTrash2, FiSearch } from 'react-icons/fi';

// const StateInfoBlock = styled.div`
//   display: flex;
// `;
// const StateInfoLabel = styled.div`
//   display: flex;
//   align-items: center;
//   & + & {
//     margin-left: 15px;
//   }
//   @media screen and (max-width: 1600px) {
//     font-size: 0.8rem;
//   }
// `;
// const StateInfoSquare = styled.div`
//   width: 1.25rem;
//   height: 1.25rem;
//   margin-right: 10px;
//   border-radius: 50%;
//   ${(props) =>
//     props.color &&
//     css`
//       background: ${props.color};
//     `}
//   ${(props) =>
//     props.valid &&
//     css`
//       border: 1px solid ${props.valid};
//     `}
// `;
// const StateInfoText = styled.span``;
// const StateCount = styled.span``;

const LockersBlock = styled.div``;

// const NoLockerBlock = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;

//   animation: 0.2s ease-in 0s both extend;
//   @keyframes extend {
//     from {
//       height: 0px;
//     }
//     to {
//       height: 300px;
//     }
//   }
// `;

// const NoLockerContentsBlock = styled.div`
//   text-align: center;
// `;

const LockerBlock = styled.div`
  padding: 24px;
  background: #ffffff;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  
  & + & {
    margin-top: 24px;
  }
  
  &:hover {
    border-color: #dee2e6;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  }
`;

const LockerName = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #212529;
`;

const CellBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
const CellBox = styled.div`
  padding: 15px;
  display: inline-block;
`;

const ConfigBlock = styled.div`
  display: flex;
  padding: 0 0 20px 0;
  margin-bottom: 20px;
  border-bottom: 2px solid #f1f3f5;
  justify-content: space-between;
  align-items: center;
`;

const ButtonBlock = styled.div`
  display: flex;
  gap: 0.75rem;
`;

const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 2px solid;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
  
  ${props => props.edit && css`
    border-color: #4a90e2;
    color: #4a90e2;
    
    &:hover {
      background: #4a90e2;
      color: white;
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(74, 144, 226, 0.25);
    }
  `}
  
  ${props => props.delete && css`
    border-color: #ff4757;
    color: #ff4757;
    
    &:hover {
      background: #ff4757;
      color: white;
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(255, 71, 87, 0.25);
    }
  `}
  
  svg {
    font-size: 1rem;
  }
`;

const ButtonCollection = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
`;

const MenuLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e9ecef;
`;

const ButtonText = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const PrimaryButton = styled(Button)`
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }
`;

const EditModeTitle = styled.h2`
  margin: 0;
  color: #4a90e2;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  &::before {
    content: '✏️';
    font-size: 1.25rem;
  }
`;

const Transition = styled.div`
  display: flex;
  gap: 0.75rem;
  
  div,
  button {
    animation: 0.2s ease-in 0s twist;

    @keyframes twist {
      from {
        transform: scale(0);
        /*transform: rotate(-2.5deg);*/
      }
      to {
        transform: scale(1);
        /*transform: rotate(2.5deg);*/
      }
    }
  }
`;

const SearchBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 20px;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
`;

const SearchInput = styled.input`
  padding: 0.5rem 1rem 0.5rem 2.25rem;
  font-size: 0.95rem;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  outline: none;
  transition: border-color 0.2s ease;

  &::placeholder {
    color: #adb5bd;
  }
  &:focus {
    border-color: #4a90e2;
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.15);
  }
`;

const SearchInputWrap = styled.div`
  position: relative;
  flex: 1;
  max-width: 280px;
  svg {
    position: absolute;
    left: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1rem;
    color: #868e96;
    pointer-events: none;
  }
  input {
    width: 100%;
    padding-left: 2.25rem;
  }
`;

const SearchHint = styled.span`
  font-size: 0.85rem;
  color: #868e96;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const ClubLocker = ({
  lockers,
  loading,
  onOpenModal,
  onSale,
  onRemove,
  isEdit,
  onEdit,
  onMouseOver,
  searchKeyword = '',
  onSearchChange,
  totalCount = 0,
  filteredCount = 0,
}) => {
  const groupByType = (lockers) => {
    if (!Array.isArray(lockers)) {
      return [];
    }

    const sortedLockers = [...lockers].sort((a, b) => {
      if (a.type !== b.type) {
        return a.type - b.type;
      }
      if (a.lockerSN !== b.lockerSN) {
        return a.lockerSN - b.lockerSN;
      }
      return a.lockerID - b.lockerID;
    });

    return sortedLockers.reduce((acc, locker) => {
      const key = locker.type;
      if (!acc[key]) acc[key] = [];
      acc[key].push(locker);
      return acc;
    }, []);
  };

  const renderLocker = (lockerBlock) => {
    return (
      <LockerBlock key={lockerBlock[0].type}>
        <ConfigBlock>
          <LockerName>{lockerBlock[0].name}</LockerName>
          <ButtonBlock>
            {isEdit && (
              <Transition>
                <ActionButton
                  edit
                  onClick={() => {
                    onOpenModal(1, lockerBlock);
                  }}
                >
                  <FiEdit2 />
                  수정
                </ActionButton>
                <ActionButton
                  delete
                  onClick={() => {
                    onOpenModal(3, lockerBlock);
                    onRemove(lockerBlock);
                  }}
                >
                  <FiTrash2 />
                  삭제
                </ActionButton>
              </Transition>
            )}
          </ButtonBlock>
        </ConfigBlock>
        <CellBlock>
          {lockerBlock.map((locker, index) => (
            <CellBox key={locker.lockerID}>
              <Cell
                locker={locker}
                number={locker.lockerSN}
                onSale={onSale}
                onOpenModal={onOpenModal}
                onMouseOver={onMouseOver}
                editMode={isEdit}
              />
            </CellBox>
          ))}
        </CellBlock>
      </LockerBlock>
    );
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      {onSearchChange && (
        <SearchBlock>
          <SearchInputWrap>
            <FiSearch />
            <SearchInput
              type="text"
              placeholder="이름으로 검색"
              value={searchKeyword}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </SearchInputWrap>
          {searchKeyword.trim() && (
            <SearchHint>
              검색 결과: {filteredCount} / {totalCount}개
            </SearchHint>
          )}
        </SearchBlock>
      )}
      <MenuLine>
        {isEdit ? <EditModeTitle>락커 편집모드</EditModeTitle> : <h2> </h2>}
        <ButtonCollection>
          {isEdit && (
            <PrimaryButton onClick={() => onOpenModal(1)}>
              <ButtonText>
                <FiPlus />
                락커 추가
              </ButtonText>
            </PrimaryButton>
          )}
          <PrimaryButton onClick={onEdit} cyan>
            {isEdit ? '편집 완료' : '락커 편집'}
          </PrimaryButton>
        </ButtonCollection>
      </MenuLine>
      <LockersBlock>
        {Array.isArray(lockers) &&
          lockers.length > 0 &&
          groupByType(lockers).map((lockerBlock) => renderLocker(lockerBlock))}
        {isEdit && (
          // <NoLockerBlock isEdit={isEdit}>
          //   <NoLockerContentsBlock>
          //     <Transition>

          //     </Transition>
          //   </NoLockerContentsBlock>
          // </NoLockerBlock>
          <></>
        )}
      </LockersBlock>
    </>
  );
};

export default ClubLocker;
